import type { CustomReport, RealTimeReport } from '@mathflat/domain/Report'
import { uniqueId } from 'lodash-es'
import { makeAutoObservable } from 'mobx'

export class ReportModelV2 {
  /**
   * 커스텀 보고서에만 있는 필드들
   */
  id: CustomReport['id']
  pdfStatus: CustomReport['pdfStatus']
  sharedToParent: CustomReport['sharedToParent']
  reportIsOpen: CustomReport['reportIsOpen']
  metric: CustomReport['metric']

  /**
   * 공통 필드들
   */
  type: RealTimeReport['type'] | CustomReport['type']
  title: RealTimeReport['title']
  studentId: RealTimeReport['studentId']
  studentName: RealTimeReport['studentName']
  year: RealTimeReport['year']
  month: RealTimeReport['month']
  startDate: RealTimeReport['startDate']
  endDate: RealTimeReport['endDate']
  createdAt: RealTimeReport['createdAt']
  chapters: CustomReport['chapters']

  constructor(data: RealTimeReport | CustomReport) {
    makeAutoObservable(this)

    if (data.type === 'REAL_TIME') {
      this.id = Number(uniqueId())
      this.pdfStatus = 'SUCCESS'
      this.sharedToParent = false
      this.reportIsOpen = null
      this.metric = {
        scoringCount: null,
        rank: null,
        correctRate: null,
      }
    } else {
      this.id = data.id
      this.pdfStatus = data.pdfStatus
      this.sharedToParent = data.sharedToParent
      this.reportIsOpen = data.reportIsOpen ?? null
      this.metric = data.metric
    }

    this.type = data.type
    this.title = data.title
    this.studentId = data.studentId
    this.studentName = data.studentName
    this.year = data.year
    this.month = data.month
    this.startDate = data.startDate
    this.endDate = data.endDate
    this.createdAt = data.createdAt
    this.chapters = data.type === 'REAL_TIME' ? [] : data.chapters
  }

  /** 올림앱에 공유된 적 있으면 true — reportIsOpen 이 null 이면 공개/비공개 개념 자체가 없다 */
  get hasCreverseShareHistory() {
    return this.reportIsOpen !== null
  }

  get isClosedToCreverse() {
    return this.reportIsOpen === false
  }

  get isOpenToCreverse() {
    return this.reportIsOpen === true
  }

  /**
   * 실시간 보고서는 서버에 저장된 커스텀 보고서 id 가 없어(클라이언트 임시 id) 전송 자체가 불가하다.
   * 이미 공유된 보고서도 재공유(재알림)는 허용한다.
   */
  get isShareableToCreverse() {
    return this.type !== 'REAL_TIME'
  }

  get isDisabled() {
    if (this.type === 'REAL_TIME') {
      return this.metric.scoringCount === null || this.metric.scoringCount === 0
    }

    return this.pdfStatus !== 'SUCCESS'
  }

  setMetric(metric: CustomReport['metric']) {
    this.metric = metric
  }
}
